<template>
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-md-5 col-lg-4 my-5">
            <div class="card bg-light bg-gradient shadow-lg rounded-4 animate__animated animate__fadeInDown">
               <div class="card-body bg-sa-card-body p-2">

                <!--Addition-->                
            <!-- Unified Alert -->
               <div v-if="showAlert" :class="['alert', `alert-${alertType}`]" role="alert">
                <i class="fa-fw fa me-2"
                   :class="alertType === 'success' ? 'fa-check' : 'fa-times'">
                </i>
                {{ alertMessage }}
              </div>
            <!--End Unified Alert -->
                <!--End Addition-->

                  <h3 class="card-title text-center mb-2">Send Code</h3>
                  <form id="forgotPasswordForm" autocomplete="off">
                  	<span>Text a Code!</span><br>
         <h1 v-if="sendingSmsCode">
               <span>{{progressMessage}}</span> <img :src="`img/progress.gif`" height="15" />
         </h1>

                     
                     <div class="mb-0">
                        <label for="password" class="form-label">Phone</label>
                        <div class="input-group">
                           <span class="input-group-text d-md-flex"><i class="fa fa-lg fa-phone"></i></span>                           
                           <input v-model="formattedPhoneNumber" @input="handleInputChange" @change="handleInputChange" type="text" class="form-control custom-tooltip-input" placeholder="Phone" disabled>
                           <div class="custom-tooltip">Please enter your Phone <span class="tooltip-arrow"></span></div>
                        </div>
                     </div>
                     <div class="d-grid mb-0">
                        <button @click="mfaCodeSubmit();" type="button" class="btn btn-primary">
                            {{smsCodeButtonText}}
                        </button>
                     </div>
                  </form>


                  <h2>Or</h2>

                  <form id="mfaSendEmailForm" autocomplete="off">
                  	<span>Email a Code!</span><br>
        <h1 v-if="sendingEmailCode">
               <span>{{progressMessage}}</span> <img :src="`img/progress.gif`" height="15" />
         </h1>

                     
                     <div class="mb-0">
                        <label for="password" class="form-label">Email</label>
                        <div class="input-group">
                           <span class="input-group-text d-md-flex"><i class="fa fa-lg fa-envelope"></i></span>                           
                           <input v-model="formattedemail" @input="handleInputChange" @change="handleInputChange" type="text" class="form-control custom-tooltip-input" placeholder="Email" disabled>
                           <div class="custom-tooltip">Please enter your Email <span class="tooltip-arrow"></span></div>
                        </div>
                     </div>
                     <div class="d-grid mb-0">
                        <button @click="mfaEmailCodeSubmit();" type="button" class="btn btn-primary">
                            {{smsCodeButtonText}}
                        </button>
                     </div>
                  </form>

                     <!--<p class="text-center text-muted mt-3 small bg-sa-login-reg-text">
                        <router-link to="/register/">
                          <a href="#" class="text-decoration-none">Sign up</a>
                        </router-link>
                     </p>
                     <p class="text-center text-muted mt-3 small bg-sa-login-reg-text">
                        <router-link to="/login/">
                         <a href="#" class="text-decoration-none small">Login</a>
                      </router-link>
                     </p>-->
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
   import { computed } from 'vue';
   import axios from 'axios'
   import emitter from '../../../main.js'
   //var Emitter = require('tiny-emitter');
   //var emitter = new Emitter();
   
    export default {
      components: {
      },
      data(){
        return {
            mfaToken: sessionStorage.getItem('mfa_token') || '', 
            sendingSmsCode: false, 
            sendingEmailCode: false, 
            showAlert: false,
            alertType: '', // 'success' or 'danger'
            alertMessage: '',
            progressMessage: 'Sending. Please wait',
            emailCodeButtonText: 'Get Verification Code',
            smsCodeButtonText: 'Get Verification Code',
            formattedPhoneNumber: sessionStorage.getItem('mfa_phone') || '', // already masked by the server
            formattedemail: sessionStorage.getItem('mfa_email') || ''        // already masked by the server
        }
      },
      created() {
            // Opened without logging in first: back to login
            if (!this.mfaToken) {
                this.$router.push('/');
            }
      },
      methods: {
            formatPhoneNumber() {
      // Remove any non-digit characters
      const cleaned = this.phonenumber.replace(/\D/g, "");
   
      // If the cleaned phone number has at least 3 digits (for basic validation)
      if (cleaned.length >= 3) {
        // Preserve the first 2 digits, mask the middle part, and show the last 2 digits
        const firstPart = cleaned.slice(0, 2);
        const lastPart = cleaned.slice(-2);
        const middlePart = cleaned.slice(2, -2).replace(/\d/g, "*"); // Mask the middle part
   
        // Combine them to form the desired format
        this.formattedPhoneNumber = `${firstPart}${middlePart}${lastPart}`;
      } else {
        // Show the number as is if it's too short
        this.formattedPhoneNumber = cleaned;
      }
    },
    maskEmail(email) {
    if (!this.email || typeof this.email !== 'string') return '';
    
    const [localPart, domain] = this.email.split('@');
    
    if (!localPart || !domain) return this.email; // invalid format fallback
   
    const visibleStart = localPart.charAt(0);
    const visibleEnd = localPart.charAt(localPart.length - 1);
    const maskedMiddle = '*'.repeat(Math.max(localPart.length - 2, 1));
    
    return `${visibleStart}${maskedMiddle}${visibleEnd}@${domain}`;
   },
        handleInputChange(event) {
         // Call the validation function for the specific input field that triggered the event
         //formValidations(event.target);
         this.$validateField(event.target);
       },
       /*mfaCodeSubmit*/
         mfaCodeSubmit(){
          const formIsValid = this.$validateForm('#forgotPasswordForm');  
          if (!formIsValid) { return; }

          this.progressMessage = 'Sending SMS Code. Please wait';
          this.sendingSmsCode=true;
          this.sendingEmailCode=false;
          const formData = new FormData();
          formData.append('mfa_token', this.mfaToken);
          formData.append('action', 'mfaSendCode'); // Indicating the action for PHP
          axios.post('/auth/api_auth.php', formData).then(response=>{ 
          console.log(response.data);     
            if (response.data.status=='mfaExpired') {
                this.$mfaRestart(response.data.message);
                return;
            }
            if (response.data.status=='success') {                  
                  localStorage.setItem('expiry_seconds', response.data.results.expiry_seconds);
                this.alertType = 'success';
               this.alertMessage = response.data.message;
               this.showAlert = true;

                this.$router.push('/mfa-verify-code/');                
            this.sendingSmsCode=false;
                     
            }else {
                //alert(response.data);
                     this.$router.push('/mfa-send-code/');   
                     this.sendingSmsCode=false;

                     this.alertType = 'danger';
               this.alertMessage = response.data.message;
               this.showAlert = true;
              
              this.$router.push('/mfa-send-code/');
            }
          })
          .catch(err=>{
                  this.$router.push('/mfa-send-code/');   
                  this.sendingSmsCode=false;
                  this.alertType = 'danger';
               this.alertMessage = err;
               this.showAlert = true;
          })
        },    
        /*End mfaCodeSubmit*/ 
        /*mfaEmailCodeSubmit*/
         mfaEmailCodeSubmit(){
          //const formIsValid = formValidations('#mfaSendEmailForm'); 
          const formIsValid = this.$validateForm('#mfaSendEmailForm');
          if (!formIsValid) { return; }

          this.progressMessage = 'Sending Email Code. Please wait';
          this.sendingEmailCode=true;
          this.sendingSmsCode=false;
          const formData = new FormData();
          formData.append('mfa_token', this.mfaToken);
          formData.append('action', 'mfaSendEmailCode'); // Indicating the action for PHP
          axios.post('/auth/api_auth.php', formData).then(response=>{ 
          console.log(response.data);     
            if (response.data.status=='success') {
                  localStorage.removeItem('mfa_email');
                  localStorage.removeItem('mfa_phone');
                  localStorage.setItem('expiry_seconds', response.data.results.expiry_seconds);

               this.alertType = 'success';
               this.alertMessage = "Please check your phone! An email with code has been sent to you!";
               this.showAlert = true;
            
                this.$router.push('/mfa-verify-code/');                
            this.sendingEmailCode=false;
                     
            }else {
                     this.$router.push('/mfa-send-code/');   
                     this.sendingEmailCode=false;

                     this.alertType = 'danger';
               this.alertMessage = response.data.message;
               this.showAlert = true;
              
              this.$router.push('/mfa-send-code/');
            }
          })
          .catch(err=>{
                  this.$router.push('/mfa-send-code/');   
                  this.sendingEmailCode=false;

                  this.alertType = 'danger';
               this.alertMessage = 'Something went wrong! Please contact admin';
               this.showAlert = true;
          })
        }    
        /*End mfaEmailCodeSubmit*/ 
      }
    };
</script>